import React from 'react'
import styles from './styles.module.css'

import Author from './components/Author'
import Brand from './components/Brand'

export const ExampleComponent = ({ text }) => {
  return <div className={styles.test}>Example Component: {text}</div>
}

export { Author }
export { Brand }
